<template>
  <transition name="show-me">
    <div v-if="accountLastOrder" class="last-orders-container__content">
      <div class="title">
        <h2>{{$t('lastorders.lastOrder')}}</h2>
      </div>
      <div class="text last-orders">
        <div class="last-orders__type">
          <span v-html="formatDate(accountLastOrder.date)"></span>
          <div class="last-orders__more-info">{{accountLastOrder.store.name}}, {{$t('lastorders.' + accountLastOrder.deliveryType)}}</div>
          <div class="last-orders__details">
            {{accountLastOrder.description}}
          </div>
        </div>
        <a v-if="!processing"
           href="javascript:void(0)"
           class="lo-price-icon lo-price-icon--sm"
           @click.prevent="onReorder(accountLastOrder)"
        ><span>{{accountLastOrder.priceFormatted}}</span>
          <SVGBasket/>
        </a>
        <div v-if="processing" class="last-orders__processing">
          Loading
          <div class="dots dots--one">.</div>
          <div class="dots dots--two">.</div>
          <div class="dots dots--three">.</div>
        </div>
      </div>

    </div>
  </transition>
</template>

<script>
  import {mapGetters} from "vuex"

  export default {
    data() {
      return {
        processing: false,
      }
    },
    computed: {
      ...mapGetters('account', [
        'accountLastOrder'
      ]),
      ...mapGetters("cart", [
        'hasCart'
      ]),
    },
    methods: {
      formatDate(value) {
        return value.format('DD. MMMM YYYY')
      },
      async onReorder(order) {
        if (!this.processing) {
          // lock this element until redirect is done
          this.processing = true
          try {
            await this.$store.dispatch('insertOrderIntoBasketAndRedirect', {order, deliveryType: order.deliveryType})
          } catch (err) {
            this.processing = false
          }
        }
      }
    },
    async mounted() {
      await this.$store.dispatch('initGlobal')
    }
  };
</script>

<style></style>
